import {inject, Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {SecurityUtils} from "../auth/security.utils";
import {GlobalResearch, SearchItem} from "./global-research.model";

@Injectable({providedIn: 'root'})
export class GlobalResearchService {

	private serviceUrl = (tenantId: string) => `${environment.engineURL}/tenants/${tenantId}/search`;

	private httpClient = inject(HttpClient);

	search(tenantId: string, query: string): Observable<GlobalResearch> {
		return this.httpClient.get<GlobalResearch>(this.serviceUrl(tenantId), {
			headers: SecurityUtils.getAuthHttpHeaders(),
			params: { query }
		});
	}

	suggestions(tenantId: string): Observable<SearchItem[]> {
		return this.httpClient.get<SearchItem[]>(`${this.serviceUrl(tenantId)}/suggestions`, {
			headers: SecurityUtils.getAuthHttpHeaders()
		});
	}
}
